/* Pro Fishing theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function storage(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key));
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return null; }
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, isError) {
    var el = $('#Toast');
    if (!el) return;
    $('.toast__text', el).textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Cart API ---------- */
  function cartFetch(path, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function updateCartCount() {
    return cartFetch('cart.js').then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    });
  }

  function addToCart(id, quantity) {
    return cartFetch('cart/add.js', { items: [{ id: Number(id), quantity: Number(quantity) || 1 }] });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    btn && btn.classList.add('is-loading');
    addToCart(form.elements.id.value, form.elements.quantity ? form.elements.quantity.value : 1)
      .then(function () { toast(T.strings.added); return updateCartCount(); })
      .catch(function (err) { toast((err && err.description) || T.strings.error, true); })
      .then(function () { btn && btn.classList.remove('is-loading'); });
  });

  /* ---------- Drawer ---------- */
  function openDrawer(drawer) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', drawer);
    panel && panel.focus();
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { var d = document.getElementById(opener.getAttribute('data-drawer-open')); d && openDrawer(d); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
  });

  /* ---------- Dropdown (todas as categorias) ---------- */
  $$('[data-dropdown]').forEach(function (dd) {
    var btn = $('[data-dropdown-toggle]', dd), panel = $('[data-dropdown-panel]', dd);
    if (!btn || !panel) return;
    function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); set(panel.hidden); });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) set(false); });
  });

  /* ---------- Escape closes things ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('[data-modal]:not([hidden])').forEach(function (m) { m.hidden = true; });
    $$('[data-dropdown-panel]').forEach(function (p) { p.hidden = true; });
    var aside = $('.collection-layout__aside.is-open');
    aside && aside.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  });

  /* ---------- Voice search ---------- */
  var Speech = window.SpeechRecognition || window.webkitSpeechRecognition;
  $$('[data-voice-search]').forEach(function (form) {
    var btn = $('[data-voice-button]', form);
    if (!btn || !Speech) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var rec = new Speech();
      rec.lang = document.documentElement.lang || 'pt-BR';
      rec.interimResults = false;
      btn.classList.add('is-listening');
      rec.onresult = function (ev) {
        var input = $('input[name="q"]', form);
        input.value = ev.results[0][0].transcript;
        form.submit();
      };
      rec.onend = function () { btn.classList.remove('is-listening'); };
      rec.start();
    });
  });

  /* ---------- Carousels ---------- */
  function initCarousel(c) {
    var track = $('[data-carousel-track]', c);
    var prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (max <= 0) { prev && (prev.hidden = true); next && (next.hidden = true); }
      else { prev && (prev.hidden = false); next && (next.hidden = false); }
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); });
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('[data-slide]', slider), dots = $$('[data-slide-dot]', slider);
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    }
    function play() {
      if (slider.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, Number(slider.dataset.speed) || 6000);
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.slideDot)); play(); }); });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', play);
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });
    play();
  });

  /* ---------- Wishlist (local) ---------- */
  var wishlist = storage('pf-wishlist') || [];
  function paintWishlist() {
    $$('[data-wishlist]').forEach(function (b) {
      var on = wishlist.indexOf(b.dataset.wishlist) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var h = b.dataset.wishlist, idx = wishlist.indexOf(h);
    if (idx > -1) wishlist.splice(idx, 1); else wishlist.push(h);
    storage('pf-wishlist', wishlist);
    paintWishlist();
  });
  paintWishlist();

  /* ---------- Modals ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) { var m = document.getElementById(opener.dataset.modalOpen); if (m) m.hidden = false; return; }
    if (e.target.closest('[data-modal-close]') || e.target.matches('[data-modal]')) {
      var modal = e.target.closest('[data-modal]');
      if (modal) { modal.hidden = true; if (modal.dataset.temp) modal.remove(); }
    }
  });

  function imageModal(src, alt) {
    var m = document.createElement('div');
    m.className = 'modal';
    m.setAttribute('data-modal', '');
    m.dataset.temp = '1';
    m.innerHTML = '<div class="modal__box modal__box--media" role="dialog" aria-modal="true"><button type="button" class="modal__close" data-modal-close aria-label="Fechar">&times;</button><img alt=""></div>';
    var img = m.querySelector('img');
    img.src = src; img.alt = alt || '';
    document.body.appendChild(m);
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var input = $('[data-qty-input]', btn.closest('[data-qty]'));
    var min = Number(input.min || 0);
    var v = Number(input.value) || 0;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Installments helper ---------- */
  function installmentsFor(price, el) {
    var max = Number(el.dataset.max) || 12, min = Number(el.dataset.min) || 0;
    var n = max;
    if (min > 0) n = Math.min(max, Math.floor(price / min));
    return n;
  }

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section), addLabel = $('[data-add-label]', section);
    var buyNow = $('[data-buy-now]', section);
    var currentVariant = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function selectedOptions() {
      return $$('.option', section).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function renderPrice(v) {
      var block = $('[data-price-block] [data-price]', section);
      if (block) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
        html += '<span class="price__current">' + formatMoney(v.price) + '</span>';
        block.innerHTML = html;
      }
      var inst = $('[data-price-block] [data-installments]', section);
      if (inst) {
        var n = installmentsFor(v.price, inst);
        inst.hidden = n < 2;
        if (n >= 2) {
          var strong = inst.querySelector('strong');
          inst.innerHTML = inst.innerHTML.replace(/\d+x/, n + 'x');
          strong = inst.querySelector('strong');
          if (strong) strong.textContent = formatMoney(Math.floor(v.price / n));
        }
      }
      var table = $('[data-installments-table]', section);
      if (table) { table.dataset.price = v.price; buildTable(table); }
    }

    function markAvailability() {
      var sel = selectedOptions();
      $$('.option', section).forEach(function (fs, idx) {
        $$('.option__pill', fs).forEach(function (pill) {
          var val = $('input', pill).value;
          var test = sel.slice(); test[idx] = val;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onVariantChange() {
      var sel = selectedOptions();
      var v = product.variants.find(function (variant) {
        return variant.options.every(function (o, i) { return o === sel[i]; });
      });
      markAvailability();
      if (!v) {
        addBtn.disabled = true; buyNow && (buyNow.disabled = true);
        addLabel.textContent = T.strings.unavailable;
        return;
      }
      currentVariant = v;
      idInput.value = v.id;
      addBtn.disabled = !v.available; buyNow && (buyNow.disabled = !v.available);
      addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      renderPrice(v);
      $$('[data-sku]', section).forEach(function (el) {
        el.hidden = !v.sku;
        var val = $('[data-sku-value]', el); if (val) val.textContent = v.sku || '';
        var sep = el.nextElementSibling;
        if (sep && sep.classList.contains('product__meta-sep')) sep.hidden = !v.sku;
      });
      if (v.featured_media) showMedia(String(v.featured_media.id));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-option-input]', section).forEach(function (input) { input.addEventListener('change', onVariantChange); });
    markAvailability();

    /* Gallery */
    function showMedia(id) {
      var slide = $('[data-media="' + id + '"]', section);
      if (!slide) return;
      $$('[data-media]', section).forEach(function (s) {
        s.classList.toggle('is-active', s === slide);
        if (s !== slide) $$('video', s).forEach(function (vid) { vid.pause(); });
      });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
    }
    $$('[data-thumb]', section).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
    $$('[data-zoom]', section).forEach(function (z) {
      z.addEventListener('click', function () { var img = $('img', z); imageModal(z.dataset.zoom, img && img.alt); });
    });

    /* Add to cart / buy now */
    function qty() { var q = $('[data-qty-input]', section); return q ? Number(q.value) || 1 : 1; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.classList.add('is-loading');
      addToCart(idInput.value, qty())
        .then(function () { toast(T.strings.added); return updateCartCount(); })
        .catch(function (err) { toast((err && err.description) || T.strings.error, true); })
        .then(function () { addBtn.classList.remove('is-loading'); });
    });
    buyNow && buyNow.addEventListener('click', function () {
      buyNow.classList.add('is-loading');
      addToCart(idInput.value, qty())
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function (err) { buyNow.classList.remove('is-loading'); toast((err && err.description) || T.strings.error, true); });
    });

    /* Installments table */
    function buildTable(table) {
      var price = Number(table.dataset.price);
      var inst = $('[data-installments]', section);
      var max = inst ? installmentsFor(price, inst) : 1;
      var rows = '';
      for (var n = 1; n <= Math.max(1, max); n++) {
        rows += '<tr><td>' + n + 'x</td><td>' + formatMoney(Math.floor(price / n)) + '</td></tr>';
      }
      table.innerHTML = '<tbody>' + rows + '</tbody>';
    }
    var t = $('[data-installments-table]', section);
    t && buildTable(t);

    /* Tabs highlight */
    var tabs = $$('.pdetails__tab', section);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === tab); });
      });
    });

    section._getVariant = function () { return currentVariant; };
    section._getQty = qty;
  });

  /* ---------- Shipping calculator ---------- */
  function onlyDigits(s) { return (s || '').replace(/\D/g, ''); }
  $$('[data-cep-input]').forEach(function (input) {
    var saved = storage('pf-cep');
    if (saved && !input.value) input.value = saved;
    input.addEventListener('input', function () {
      var d = onlyDigits(input.value).slice(0, 8);
      input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var b = $('[data-cep-submit]', input.closest('[data-shipping-calc]')); b && b.click(); }
    });
  });

  function pollRates(params, tries) {
    return fetch(root + 'cart/async_shipping_rates.json?' + params, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        if (res.data && res.data.shipping_rates) return res.data.shipping_rates;
        if (res.status >= 400) throw res.data;
        if (tries > 12) return [];
        return new Promise(function (resolve) { setTimeout(resolve, 500); }).then(function () { return pollRates(params, tries + 1); });
      });
  }

  function getRates(zip, uf) {
    var params = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) +
      '&shipping_address%5Bcountry%5D=Brazil' +
      (uf ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf) : '');
    return fetch(root + 'cart/prepare_shipping_rates.json?' + params, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return pollRates(params, 0);
      });
  }

  function lookupCep(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; });
  }

  function renderRates(box, rates, addr) {
    var html = '';
    if (addr && addr.localidade) {
      html += '<p class="shipping-calc__address">' + [addr.logradouro, addr.bairro, addr.localidade + '/' + addr.uf].filter(Boolean).join(' · ') + '</p>';
    }
    if (!rates || !rates.length) {
      html += '<p class="shipping-calc__error">' + T.strings.cepNoRates + '</p>';
    } else {
      html += '<ul class="shipping-rates">' + rates.map(function (r) {
        var price = Number(r.price) === 0 ? T.strings.cepFree : formatMoney(Math.round(Number(r.price) * 100));
        var days = '';
        if (r.delivery_days && r.delivery_days.length) {
          var a = r.delivery_days[0], b = r.delivery_days[r.delivery_days.length - 1];
          days = ' <small>(' + (a === b ? a : a + '–' + b) + ' dias úteis)</small>';
        }
        return '<li><span>' + r.name + days + '</span><strong>' + price + '</strong></li>';
      }).join('') + '</ul>';
    }
    box.innerHTML = html;
  }

  $$('[data-shipping-calc]').forEach(function (calc) {
    var btn = $('[data-cep-submit]', calc), input = $('[data-cep-input]', calc), out = $('[data-cep-result]', calc);
    var cartMode = calc.hasAttribute('data-cart-mode');
    btn.addEventListener('click', function () {
      var cep = onlyDigits(input.value);
      if (cep.length !== 8) { out.innerHTML = '<p class="shipping-calc__error">' + T.strings.cepInvalid + '</p>'; return; }
      storage('pf-cep', input.value);
      btn.classList.add('is-loading');
      out.textContent = T.strings.cepLoading;
      var formattedZip = cep.slice(0, 5) + '-' + cep.slice(5);

      lookupCep(cep).then(function (addr) {
        if (addr && addr.erro) { throw { message: T.strings.cepInvalid }; }
        var uf = addr && addr.uf;
        if (cartMode) return getRates(formattedZip, uf).then(function (rates) { renderRates(out, rates, addr); });

        // Product mode: temporarily add the selected variant, read rates, then restore the cart.
        var section = calc.closest('[data-product-section]');
        var variant = section && section._getVariant ? section._getVariant() : null;
        var q = section && section._getQty ? section._getQty() : 1;
        if (!variant) throw {};
        var originalQty = 0, lineKey = null;
        return cartFetch('cart.js').then(function (cart) {
          cart.items.forEach(function (it) { if (it.variant_id === variant.id && !lineKey) { originalQty = it.quantity; } });
          return addToCart(variant.id, q);
        }).then(function (added) {
          lineKey = added.items && added.items[0] && added.items[0].key;
          return getRates(formattedZip, uf).then(function (rates) { renderRates(out, rates, addr); });
        }).then(function () {
          if (lineKey) return cartFetch('cart/change.js', { id: lineKey, quantity: originalQty });
        }, function (err) {
          if (lineKey) cartFetch('cart/change.js', { id: lineKey, quantity: originalQty });
          throw err;
        });
      }).catch(function (err) {
        var msg = (err && (err.message || err.description)) || T.strings.cepNoRates;
        if (err && err.zip) msg = T.strings.cepInvalid;
        out.innerHTML = '<p class="shipping-calc__error">' + msg + '</p>';
      }).then(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* ---------- Facets ---------- */
  var facetsForm = $('[data-facets-form]');
  function submitFacets() {
    if (!facetsForm) return;
    var fd = new FormData(facetsForm);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    window.location.search = params.toString();
  }
  if (facetsForm) {
    var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
    facetsForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-facet-input]') && isDesktop()) submitFacets();
    });
    facetsForm.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });

    $$('[data-facet-more]', facetsForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var list = b.previousElementSibling;
        list.classList.toggle('is-expanded');
        b.textContent = list.classList.contains('is-expanded') ? '- Ver menos' : '+ Ver mais';
      });
    });

    $$('[data-price-range]', facetsForm).forEach(function (pr) {
      var max = Number(pr.dataset.max) || 0;
      var rMin = $('[data-range-min]', pr), rMax = $('[data-range-max]', pr);
      var iMin = $('[data-range-min-input]', pr), iMax = $('[data-range-max-input]', pr);
      var fill = $('[data-range-fill]', pr);
      function paint() {
        var a = Number(rMin.value), b = Number(rMax.value);
        if (max > 0) { fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
      }
      var commit = debounce(function () { if (isDesktop()) submitFacets(); }, 700);
      rMin.addEventListener('input', function () {
        if (Number(rMin.value) > Number(rMax.value)) rMin.value = rMax.value;
        iMin.value = rMin.value; paint();
      });
      rMax.addEventListener('input', function () {
        if (Number(rMax.value) < Number(rMin.value)) rMax.value = rMin.value;
        iMax.value = rMax.value; paint();
      });
      [rMin, rMax].forEach(function (r) { r.addEventListener('change', commit); });
      iMin.addEventListener('change', function () { rMin.value = iMin.value || 0; paint(); commit(); });
      iMax.addEventListener('change', function () { rMax.value = iMax.value || max; paint(); commit(); });
      paint();
    });
  }

  var aside = $('#FacetsDrawer');
  document.addEventListener('click', function (e) {
    if (!aside) return;
    if (e.target.closest('[data-facets-open]')) { aside.classList.add('is-open'); document.body.classList.add('no-scroll'); }
    else if (e.target.closest('[data-facets-close]') || e.target === aside) { aside.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  });

  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (facetsForm) {
        var hidden = $('[data-sort-hidden]', facetsForm);
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'sort_by'; hidden.setAttribute('data-sort-hidden', '');
          facetsForm.appendChild(hidden);
        }
        hidden.value = sel.value;
        submitFacets();
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }
    });
  });

  /* ---------- Grid / list toggle ---------- */
  var grid = $('[data-product-grid]');
  if (grid) {
    var btns = $$('[data-view]');
    function setView(v) {
      grid.classList.toggle('is-list', v === 'list');
      btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.view === v); });
      storage('pf-view', v);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.view); }); });
    if (storage('pf-view') === 'list' && window.matchMedia('(min-width: 990px)').matches) setView('list');
  }

  /* ---------- Cart page auto update ---------- */
  var cartForm = $('#CartForm');
  if (cartForm) {
    var submitUpdate = debounce(function () {
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = 'update'; input.value = '1';
      cartForm.appendChild(input);
      cartForm.submit();
    }, 600);
    $$('[data-cart-qty]', cartForm).forEach(function (i) { i.addEventListener('change', submitUpdate); });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) {
        el.innerHTML = inner.innerHTML;
        $$('[data-carousel]', el).forEach(initCarousel);
        paintWishlist();
      } else {
        el.remove();
      }
    }).catch(function () {});
  });
})();
